var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_vm._v(" Sorry, you don't have access to this page. "),(_vm.$route.query.expired)?_c('div',[_vm._v("Your session has expired.")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }